import { useSelector } from "react-redux";
import { SpaceWrapper } from "../../components";
import AvailableBalance from "./AvailableBalance";
import RechargeWallet from "./RechargeWallet";
import ViewYourWallet from "./ViewYourWallet";

const Wallet = () => {
  const walletBalance = useSelector((state) => state.wallet?.balance) || 0;
  const user = useSelector((state) => state.user.user) || {};
  return (
    <SpaceWrapper>
      <section className="w-full flex-1 flex flex-col gap-4 p-4 pb-20 md:pb-4 relative max-w-[2000px]">
        <h2 className="text-headline3 lg:text-headline2 font-nunito font-bold text-secondary/95">
          ICC Wallet
        </h2>
        <div className="space-y-4">
          <AvailableBalance initialBalance={walletBalance} />
          <div className="flex w-fit flex-col gap-4">
            <RechargeWallet user={user} />
            <ViewYourWallet />
          </div>
        </div>
      </section>
    </SpaceWrapper>
  );
};

export default Wallet;
